import { FlexBox, Tag } from '@dixa/lib-shared-habla';
import { UserType } from 'lib-shared-types-api';

import { UserAuditLogEntry } from 'apis/auditLogs';
import { conversationStatusAttributes } from 'utils/conversation';

import { UserLink } from '../activityTypes/userLink/userLink';

import { ConversationLink } from './conversationLink/conversationLink';
import { UserActivityCard } from './userActivityCard';
import { channelRefIcon, statusColors } from './userActivityTypes.utils';

type ConversationAssignedProps = {
  entry: UserAuditLogEntry<'CONVERSATION_ASSIGNED'>;
  userType: UserType;
};

export const ConversationAssigned = ({
  entry,
  userType,
}: ConversationAssignedProps): JSX.Element => {
  const status = entry.conversation_state
    ? conversationStatusAttributes[entry.conversation_state]
    : null;

  return (
    <UserActivityCard
      entry={entry}
      icon={channelRefIcon(entry.channel_ref)}
      color={statusColors.info}
      title={
        entry.is_reassigned
          ? 'Reassigned to conversation'
          : 'Assigned to conversation'
      }
      titleSuffix={
        <ConversationLink conversationId={entry.conversation_id}>
          #{entry.conversation_id}
        </ConversationLink>
      }
      summary={
        <FlexBox flexDirection="column">
          {status && (
            <span>
              Status
              <Tag color={status.color} noBorder>
                {status.label}
              </Tag>
            </span>
          )}
          {userType === 'member' && entry.contact_id && (
            <span>
              {'With '}
              <UserLink userId={entry.contact_id}>
                {entry.contact_name ?? entry.contact_id}
              </UserLink>
            </span>
          )}
          {userType === 'contact' && entry.assigned_agent_id && (
            <span>
              {'To '}
              <UserLink userId={entry.assigned_agent_id}>
                {entry.assigned_agent_name ?? entry.assigned_agent_id}
              </UserLink>
            </span>
          )}
        </FlexBox>
      }
    />
  );
};
